import React from 'react';
import cs from 'classnames';

import css from './index.css';

const Spinner = (props) => (
  <div
    className={cs(
      css.wrap,
      props.scalable && css.scalable,
      `qa-spinner-${props.qa}`
    )}
  >
    <div className={css.first}/>
    <div className={css.second}/>
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner/index.js